import { useTranslation } from 'react-i18next'

import { ArrowsCounterClockwiseIcon, MapPinLineIcon } from '@phosphor-icons/react'

import { Button, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SearchAddressInfo = ({ address, onChangeAddress }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <MapPinLineIcon size={24} weight="thin" />
      <Styles.InfoContainer>
        <Text type="bodySRegular">{t('Mostrando puntos de recogida cercanos a:')}</Text>
        <Text type="bodySBold">{address}</Text>
      </Styles.InfoContainer>
      <Button variant="text" size="s" onClick={onChangeAddress}>
        <ArrowsCounterClockwiseIcon size={16} weight="light" />
        {t('Cambiar')}
      </Button>
    </Styles.Container>
  )
}

export default SearchAddressInfo
